import React from 'react';
import PropTypes from 'prop-types';
import { TabBar, TabButton } from '~/components';

export default function SubRouteSwitch({
  onChange,
  value,
  className,
  homeName,
  awayName,
  styleTab,
}) {
  return (
    <TabBar
      value={value}
      onChange={onChange}
      className={className}
      styleTab={styleTab}
    >
      <TabButton value="local" label={homeName} />
      <TabButton value="away" label={awayName} />
    </TabBar>
  );
}

SubRouteSwitch.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  className: PropTypes.string,
  homeName: PropTypes.string,
  awayName: PropTypes.string,
  styleTab: PropTypes.object,
};

SubRouteSwitch.defaultProps = {
  onChange: () => {},
  value: '',
  className: '',
  homeName: '--',
  awayName: '--',
  styleTab: false,
};
